<script lang="ts">
	import ThemeLoader from '$lib/components/theme/ThemeLoader.svelte'

	let { children } = $props()
</script>

<ThemeLoader />

{@render children?.()}
